import React from 'react';
import { TopicBookmark } from '../mixins/mixins';
import { TopicStylesProps } from '../topicStyle';
import { DefaultBookmarkItem } from './defaultBookmarkItem';

export default function DefaultBookmarkList({
	style,
	setStyle,
	setIsValid
}: TopicStylesProps) {
	const addBookmark = () => {
		let newBookmarks: TopicBookmark[] = [];
		if (style.defaultBookmarkList != null)
			newBookmarks = style.defaultBookmarkList;
		newBookmarks.push({
			name: '',
			url: ''
		});

		setStyle({
			...style,
			defaultBookmarkList: newBookmarks
		});
	};

	return (
		<>
			<div className="flex flex-row">
				<h3 className="text-left pl-18 -mt-3 mb-4 sm:mt-2 text-xl sm:text-3xl font-bold text-gray-600 dark:text-gray-500">
					Default Bookmarks
				</h3>
				<div className="flex flex-1 justify-end">
					<button
						className="btn btn-outline btn-sm btn-primary ml-auto mt-1 mr-8"
						onClick={(e) => {
							e.preventDefault();
							addBookmark();
						}}
					>
						Add ➕
					</button>
				</div>
			</div>
			{style.defaultBookmarkList != null &&
				style.defaultBookmarkList.map((item: TopicBookmark, index) => (
					<DefaultBookmarkItem
						item={item}
						index={index}
						style={style}
						setStyle={setStyle}
						setIsValid={setIsValid}
					/>
				))}
		</>
	);
}
